import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button } from '@cian/button-component';
import * as React from 'react';
import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { isEmail, isValidPhone } from '../../utils/validation';
import { ViewContainer } from '../../containers/ViewContainer';
import * as styles from './styles.css';
import { trackTwoFactorAttemptsExhaustedSupportClick } from '../../utils/tracking';
import { ETwoFactorType } from '../../types/authentication';
export var TwoFactorAttemptsExhaustedView = /*#__PURE__*/function (_React$Component) {
  _inherits(TwoFactorAttemptsExhaustedView, _React$Component);

  var _super = _createSuper(TwoFactorAttemptsExhaustedView);

  function TwoFactorAttemptsExhaustedView() {
    var _this;

    _classCallCheck(this, TwoFactorAttemptsExhaustedView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleSupportClick", function (event) {
      event.preventDefault();
      var _this$props = _this.props,
          viewData = _this$props.viewData,
          login = _this$props.login,
          emit = _this$props.emit;
      var phone = viewData && viewData.phone;
      trackTwoFactorAttemptsExhaustedSupportClick(phone ? ETwoFactorType.Sms : ETwoFactorType.Email);
      var contactQuery = [isEmail(login) ? "email=".concat(encodeURIComponent(login)) : null, phone && isValidPhone(phone) ? "phone=".concat(encodeURIComponent("+".concat(phone.replace(/\D+/g, '')))) : null, 'twoFactor=true'].filter(Boolean).join('&');
      emit(EEventType.TwoFactorAttemptsExhaustedSupportClick);
      window.open("/contacts/?".concat(contactQuery), '_blank');
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackClick", function () {
      var _this$props2 = _this.props,
          login = _this$props2.login,
          reset = _this$props2.reset,
          changeLogin = _this$props2.changeLogin;
      reset();
      changeLogin(login);
    });

    return _this;
  }

  _createClass(TwoFactorAttemptsExhaustedView, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(ViewContainer, {
        prevView: EActiveView.AuthenticationRegistration,
        onBack: this.handleBackClick
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles['header']
      }, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u0445\u043E\u0434\u0430"), /*#__PURE__*/React.createElement("p", {
        className: styles['description']
      }, "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 \u043D\u0430 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0432\u0432\u043E\u0434\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0430. \u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u0434\u043B\u044F \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B."), /*#__PURE__*/React.createElement(Button, {
        onClick: this.handleSupportClick
      }, "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C"));
    }
  }]);

  return TwoFactorAttemptsExhaustedView;
}(React.Component);